import { TFunction } from "i18next";

const WIDGET_CDN_URL = process.env.REACT_APP_WIDGET_CDN_URL;

/**
 * 檔案上傳限制 (API: /assets/upload)
 */
const IMAGE_SIZE_LIMIT = 20 * 1024 * 1024; // 20MB
const VIDEO_SIZE_LIMIT = 150 * 1024 * 1024; // 150MB
const AUDIO_SIZE_LIMIT = 80 * 1024 * 1024; // 80MB
const VRM_SIZE_LIMIT = 50 * 1024 * 1024; // 50MB

/**
 * 檔案類型限制 (API: /assets/upload)
 */
const ACCEPT_AUDIO_TYPES = ["mp3"];
const ACCEPT_VIDEO_TYPES = ["mp4"];
const ACCEPT_IMAGE_TYPES = ["image/jpg", "image/jpeg", "image/png", "image/gif"];
const ACCEPT_WEBM_VIDEO_TYPES = ["webm"];
const ACCEPT_VRM_TYPES = [".vrm"];

/**
 * Kiosk提示詞-字數限制配置（所有語言統一上限）
 */
const HINT_LENGTH_LIMITS = {
    MAX: 50,
} as const;

/**
 * 自訂濾鏡上限數量
 */
const MAX_CUSTOM_FILTERS = 10;

/**
 * Kiosk-QR Code 圖片尺寸限制
 * 最小 200x200 像素，最大 300x300 像素
 */
const QR_IMAGE_MIN_SIZE = 200;
const QR_IMAGE_MAX_SIZE = 300;

/**
 * Kiosk-官方Line ID
 */
export const LINE_ID_VALUE = "@159kdmqh";

/**
 * Kiosk-節慶模式設定
 * @bgm 是否套用背景音樂，關閉的話就播放預設音樂
 * @bg 是否套用背景
 * @bg_obj 是否套用背景物件 (有些背景有物件動畫，例如飄動的竹葉，部分效能較差的設備會關閉)
 * @effect 是否套用特效 (顯示在畫面的背景，例如雪花，部分效能較差的設備會關閉)
 * @character 是否套用角色
 * @character_is_conservative 是否使用保守角色 (有些角色衣服設計有兩款)
 * @filter 是否啟用濾鏡
 * @filter_keep_defult 是否保留預設濾鏡
 */
export const FESTIVAL_SETTINGS = (t: TFunction) => [
    {
        label: t("APPWIDGET.FESTIVAL_BGM") || "背景音樂",
        name: "bgm",
    },
    {
        label: t("APPWIDGET.FESTIVAL_BG") || "節慶背景",
        name: "bg",
    },
    {
        label: t("APPWIDGET.FESTIVAL_BG_OBJ") || "節慶裝飾物件",
        name: "bg_obj",
    },
    {
        label: t("APPWIDGET.FESTIVAL_EFFECT") || "節慶特效",
        name: "effect",
    },
    {
        label: t("APPWIDGET.FESTIVAL_CHARACTER") || "節慶角色主題",
        name: "character",
    },
    {
        label: t("APPWIDGET.FESTIVAL_CHARACTER_CONSERVATIVE") || "保守角色模式",
        name: "character_is_conservative",
    },
    {
        label: t("APPWIDGET.FESTIVAL_FILTER") || "節慶濾鏡",
        name: "filter",
    },
    {
        label: t("APPWIDGET.FESTIVAL_FILTER_KEEP_DEFAULT") || "保留預設濾鏡",
        name: "filter_keep_default",
    },
];

// 從 S3 取得語言資料 (由Unity提供)
const S3_ENDPOINT_MAP = {
    GET_KIOSK_LANGUAGE: "/Common/Backend/Language.json",
};

/**
 * 縣市資料 (用於氣象站篩選)
 */
const WEATHER_COUNTY = [
    { county_code: "taipei", county_name: "臺北市" },
    { county_code: "new_taipei", county_name: "新北市" },
    { county_code: "keelung", county_name: "基隆市" },
    { county_code: "taoyuan", county_name: "桃園市" },
    { county_code: "hsinchu_county", county_name: "新竹縣" },
    { county_code: "hsinchu_city", county_name: "新竹市" },
    { county_code: "miaoli", county_name: "苗栗縣" },
    { county_code: "taichung", county_name: "臺中市" },
    { county_code: "changhua", county_name: "彰化縣" },
    { county_code: "nantou", county_name: "南投縣" },
    { county_code: "yunlin", county_name: "雲林縣" },
    { county_code: "chiayi_county", county_name: "嘉義縣" },
    { county_code: "chiayi_city", county_name: "嘉義市" },
    { county_code: "tainan", county_name: "臺南市" },
    { county_code: "kaohsiung", county_name: "高雄市" },
    { county_code: "pingtung", county_name: "屏東縣" },
    { county_code: "yilan", county_name: "宜蘭縣" },
    { county_code: "hualien", county_name: "花蓮縣" },
    { county_code: "taitung", county_name: "臺東縣" },
    { county_code: "penghu", county_name: "澎湖縣" },
    { county_code: "kinmen", county_name: "金門縣" },
    { county_code: "lienchiang", county_name: "連江縣" },
];

export {
    ACCEPT_AUDIO_TYPES,
    ACCEPT_IMAGE_TYPES,
    ACCEPT_VIDEO_TYPES,
    ACCEPT_VRM_TYPES,
    ACCEPT_WEBM_VIDEO_TYPES,
    AUDIO_SIZE_LIMIT,
    HINT_LENGTH_LIMITS,
    IMAGE_SIZE_LIMIT,
    MAX_CUSTOM_FILTERS,
    QR_IMAGE_MAX_SIZE,
    QR_IMAGE_MIN_SIZE,
    S3_ENDPOINT_MAP,
    VIDEO_SIZE_LIMIT,
    VRM_SIZE_LIMIT,
    WEATHER_COUNTY,
    WIDGET_CDN_URL,
};
